import { useEffect, useState } from "react";
import { useAuth } from "@workos-inc/authkit-react";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  SettingsDialogContent,
  SettingsDialogFooter,
  SettingsDialogHeader,
} from "@/components/ui/settings-dialog";
import {
  acknowledgeSessionExpired,
  subscribeSessionExpired,
} from "@/lib/session-expired-bus";

export function SessionExpiredModal() {
  const { signIn } = useAuth();
  const [open, setOpen] = useState(false);
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    return subscribeSessionExpired(() => {
      setOpen(true);
    });
  }, []);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) return;
        setOpen(next);
      }}
    >
      <SettingsDialogContent
        size="sm"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <SettingsDialogHeader
          title="Your session has expired"
          description="Sign back in to keep working. Anything you've typed will stay where it is."
        />
        <SettingsDialogFooter>
          <Button
            disabled={signingIn}
            onClick={async () => {
              setSigningIn(true);
              acknowledgeSessionExpired();
              try {
                await signIn();
              } finally {
                setSigningIn(false);
              }
            }}
          >
            {signingIn ? "Redirecting…" : "Sign back in"}
          </Button>
        </SettingsDialogFooter>
      </SettingsDialogContent>
    </Dialog>
  );
}
